module.exports = __webpack_public_path__ + "static/League_Gothic-webfont-d83d9abf6632f1dae081d25f19072a57.ttf";